/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFPrivacyCookieCompliance } from './CRSFPrivacyCookieCompliance';
import {
    CRSFPrivacyCookieComplianceFromJSON,
    CRSFPrivacyCookieComplianceFromJSONTyped,
    CRSFPrivacyCookieComplianceToJSON,
} from './CRSFPrivacyCookieCompliance';

/**
 * 
 * @export
 * @interface CRSFPrivacyTechnologiesResult
 */
export interface CRSFPrivacyTechnologiesResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    advertising: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    analytics: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    chatbot: Array<string>;
    /**
     * 
     * @type {Array<CRSFPrivacyCookieCompliance>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    cookie_compliance: Array<CRSFPrivacyCookieCompliance>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    fingerprinting: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    geolocation: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFPrivacyTechnologiesResult
     */
    tag_manager: Array<string>;
}

/**
 * Check if a given object implements the CRSFPrivacyTechnologiesResult interface.
 */
export function instanceOfCRSFPrivacyTechnologiesResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "advertising" in value;
    isInstance = isInstance && "analytics" in value;
    isInstance = isInstance && "chatbot" in value;
    isInstance = isInstance && "cookie_compliance" in value;
    isInstance = isInstance && "fingerprinting" in value;
    isInstance = isInstance && "geolocation" in value;
    isInstance = isInstance && "tag_manager" in value;

    return isInstance;
}

export function CRSFPrivacyTechnologiesResultFromJSON(json: any): CRSFPrivacyTechnologiesResult {
    return CRSFPrivacyTechnologiesResultFromJSONTyped(json, false);
}

export function CRSFPrivacyTechnologiesResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyTechnologiesResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'advertising': json['advertising'],
        'analytics': json['analytics'],
        'chatbot': json['chatbot'],
        'cookie_compliance': ((json['cookie_compliance'] as Array<any>).map(CRSFPrivacyCookieComplianceFromJSON)),
        'fingerprinting': json['fingerprinting'],
        'geolocation': json['geolocation'],
        'tag_manager': json['tag_manager'],
    };
}

export function CRSFPrivacyTechnologiesResultToJSON(value?: CRSFPrivacyTechnologiesResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'advertising': value.advertising,
        'analytics': value.analytics,
        'chatbot': value.chatbot,
        'cookie_compliance': ((value.cookie_compliance as Array<any>).map(CRSFPrivacyCookieComplianceToJSON)),
        'fingerprinting': value.fingerprinting,
        'geolocation': value.geolocation,
        'tag_manager': value.tag_manager,
    };
}

